import { log } from "../../utils";
import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";
import { VisitorInfoMessage } from "../../xapp/ChatServer";

export default function sendVisitorInfo(msg: VisitorInfoMessage, sessionId): ChatServerAsyncActionType {
    return chatServer => () => {
        chatServer.setVisitorInfo(msg, sessionId, (err?: Error) => {
            if (err) {
                log(err);
            }
        });
    };
}